<template>
  <div>
    <div class="author-list">
      <div class="author-box" v-for="(item, index) in authorList" :key="index">
        <div class="author-avatar flex-center" @click="toDetail(item.authorId)">
          <img
            :src="
              item.authorPortrait == null ? defaultImg : item.authorPortrait
            "
            alt=""
          />
        </div>
        <div class="right-author-content">
          <div class="name" @click="toDetail(item.authorId)">
            <span
              class="ellipsis-aRow"
              v-html="eachColor(item.authorName, searchName,$store.state.read.searchText)"
            ></span>
          </div>
          <div class="author-info">
            <div>
              <span>学术领域：</span>

              <el-tooltip
                :content="item.academicField"
                placement="top"
                v-ak-tooltip-auto-show
              >
                <span class="ellipsis-aRow">{{ item.academicField }}</span>
              </el-tooltip>
            </div>
            <div>
              <span>商品数量：</span>
              <span class="ellipsis-aRow">{{ item.resourceCount }}本</span>
            </div>
            <div>
              <span>所属机构：</span>
              <el-tooltip
                :content="item.cpName"
                placement="top"
                v-ak-tooltip-auto-show
              >
                <span class="ellipsis-aRow">{{ item.cpName }}</span>
              </el-tooltip>
            </div>
          </div>
          <p class="ellipsis-twoRow">{{ item.introduction }}</p>
        </div>
      </div>
    </div>
    <noData v-if="total == 0"></noData>
    <!-- <el-pagination
      style="float: right; margin-top: 28px"
      v-show="total > 0"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryParams.pageNum"
      :page-sizes="[10, 20, 30, 40, 50]"
      :page-size="queryParams.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination> -->
    <div class="pagination-box" v-show="total > 0">
      <el-pagination
        class="ou-pagination"
        background
        hide-on-single-page
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryParams.pageNum"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="queryParams.pageSize"
        layout="total, prev, pager, next, sizes, jumper, slot"
        :total="total"
      >
        <el-button @click="getList()" class="ou-page-go">GO</el-button>
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { selectAuthors } from "@/api/index/index";
import noData from "@/components/noData.vue";
export default {
  data() {
    return {
      defaultImg: require("@/assets/images/default-avatar.jpg"),
      total: 0,
      authorList: [], //右侧作者列表
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        authorName: null,
      },
    };
  },
  props: {
    searchName: String,
    eachColor: Function,
  },
  components: {
    noData,
  },
  methods: {
    getList(word = undefined) {
			console.log(1)
      // 右侧作者列表
      var Params = {
        ...this.queryParams,
        word1:word||undefined,
        word2:this.$store.state.read.searchText||undefined
      };
      selectAuthors(Params).then((res) => {
        this.authorList = res.rows;
        this.total = res.total;
        this.$emit("settotal", "zztotal", res.total);
      });
    },
    toDetail(id) {
      this.$router.push({
        path: "/authorLibrary/authorDetail",
        query: {
          authorId: id,
        },
      });
    },
    //每页条数
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.getList();
    },
    //当前页数
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getList();
    },
  },
};
</script>
<style scoped lang='scss'>
.author-list {
  .author-box {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding: 30px 0;
    border-bottom: 1px solid #f2f2f2;

    .author-avatar {
      width: 130px;
      height: 130px;
      margin-right: 40px;
      cursor: pointer;

      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }

    .right-author-content {
      width: calc(100% - 150px);

      .name {
        display: flex;

        span {
          display: block;
          max-width: 700px;
        }

        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #333333;
        margin-bottom: 20px;
        cursor: pointer;
      }

      .name > span:hover {
        color: #1690ff;
        text-decoration: underline;
      }

      .author-info {
        width: 730px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #666666;
        margin-bottom: 20px;

        > div {
          display: flex;
          align-items: center;

          span:last-child {
            display: block;
          }
        }

        > div:nth-of-type(1) {
          span:last-child {
            width: 110px;
          }
        }

        > div:nth-of-type(3) {
          span:last-child {
            width: 180px;
          }
        }
      }

      p {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 26px;
      }
    }
  }
}
.el-pagination {
  margin-top: 30px;
      text-align: right;
    }
</style>
